import React from 'react';
import { List, Space, Typography } from 'antd';
import dayjs from 'dayjs';
import { ICommit } from '../../store/GitStatistics';
import {
  colorSecondary,
  commitDescription,
  commitMessage,
  commitTitle,
  fullWidth,
  linkRepositoryContainer,
  list,
} from './styles';
import { colorGreen, colorRed } from '../../styles/styles';

const CommitsListView = ({ commitsList }: { commitsList: ICommit[] }) => {
  return (
    <List
      header={<Typography.Text strong>Commits List: </Typography.Text>}
      dataSource={commitsList || []}
      split={false}
      style={list}
      renderItem={(commit, index) => {
        return (
          <List.Item>
            <Space direction="vertical" style={fullWidth}>
              <div style={commitTitle}>
                <div style={commitMessage}>
                  <Typography.Text strong>#{index + 1}</Typography.Text>
                  <Typography.Text strong>{commit.message}</Typography.Text>
                </div>
                <Typography.Text strong>
                  {dayjs(commit.date).format('YYYY-MM-DD')}
                </Typography.Text>
              </div>
              <div style={commitDescription}>
                <div style={linkRepositoryContainer}>
                  <Typography.Link
                    strong
                    target="_blank"
                    rel="noopener noreferrer"
                    href={commit.url}
                  >
                    Link
                  </Typography.Link>
                  <div>
                    <Typography.Text strong style={colorSecondary}>
                      Repository:{' '}
                    </Typography.Text>
                    <Typography.Text strong style={colorSecondary}>
                      {commit.repository.name}
                    </Typography.Text>
                    <Typography.Text strong style={colorSecondary}>
                      {' '}
                      |{' '}
                    </Typography.Text>
                    <Typography.Text strong style={colorSecondary}>
                      Project:{' '}
                    </Typography.Text>
                    <Typography.Text strong style={colorSecondary}>
                      {commit.project.name}
                    </Typography.Text>
                  </div>
                </div>
                <div>
                  <Typography.Text strong style={colorGreen}>
                    +{commit.added}
                  </Typography.Text>
                  <Typography.Text strong> / </Typography.Text>
                  <Typography.Text strong style={colorRed}>
                    -{commit.removed}
                  </Typography.Text>
                </div>
              </div>
            </Space>
          </List.Item>
        );
      }}
    />
  );
};

export default CommitsListView;
